<template>
  <v-container class="no-margins">
    <div class="title-icon">
      <h1 class>{{ $t("labels.instructor") }}</h1>

      <v-btn
        icon
        :href="links.ebook.apprenticeInfo"
        target="_blank"
      >
        <v-icon>$sl-question</v-icon>
      </v-btn>
    </div>

    <v-card flat>
      <v-list class="height-small">
        <v-list-item-group v-model="instructor" :multiple="false" :mandatory="true">
          <template class v-for="(inst, index) in instructors">
            <v-list-item :key="index">
              <v-list-item-icon>
                <v-icon>$sl-instructor</v-icon>
              </v-list-item-icon>

              <v-list-item-content class="ml-3">
                <v-list-item-title class="body-1">{{
                  inst.instructor.employed.firstName +
                  " " +
                  inst.instructor.employed.lastName
                }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <div class="v-list-item__radio">
                  <input type="radio" v-model="instructor" :value="index" />
                  <div class="check">
                    <div class="inside"></div>
                  </div>
                </div>
              </v-list-item-action>
            </v-list-item>
            <v-divider :key="inst.id"></v-divider>
          </template>
        </v-list-item-group>
      </v-list>
    </v-card>

    <NextButton :isDisabled="instructor < 0 || isImitatingUser()" @click="next">{{
      $t("ebook.elementpart")
    }}</NextButton>
    <BottomNav @clicked="goback" />
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import API from "@/services/api.js";
import find from "lodash/find";
import NextButton from "@/components/Common/NextButton";
import BottomNav from "@/components/Application/BottomNav";

// @group Ebook
// Styled EbookInstructor component
export default {
  name: "EbookInstructor",

  props: {
    //has current report
    currentReport: {
      // `'Object'`
      type: Object,
    },
  },

  components: {
    BottomNav,
    NextButton,
  },

  data: () => ({
    links: require('../../../lib/external-links.json'),
    instructors: [],

    instructor: -1,

    report: {},
  }),

  created() {
    this.init();
  },

  watch: {
    currentReport(val) {
      this.initReport();
    },
    instructor: function () {
      if (this.instructor === undefined) {
      }
    },
  },

  computed: {
    ...mapGetters("currentuser", ["currentUser", "isApprentice", "isInstructor", "isImitatingUser"]),
  },

  methods: {
    init() {
      if (
        this.currentUser &&
        this.currentUser.books &&
        this.currentUser.books.length > 0
      ) {
        const book = this.currentUser.books.find(
          (x) => x.id === this.currentReport.bookId
        );
        if (
          book &&
          book.apprenticeship &&
          book.apprenticeship.apprenticeshipInstructors
        ) {
          this.instructors = book.apprenticeship.apprenticeshipInstructors;
        }

        this.initReport();
      }
    },

    initReport() {
      if (this.currentReport && this.currentReport.instructorId) {
        this.report = this.currentReport;
        this.instructor = this.instructors.findIndex(
          (x) => x.instructor.employed.id === this.currentReport.instructor.employed.id
        );
      } else {
        this.report = this.currentReport;
        this.instructor = 0;
      }
    },
    goback() {
      // Fire go back
      // @arg The argument is a object representing report
      this.$emit("goto", { report: this.report, goto: "workplace" });
    },
    /**
     * @vuese
     * Used to go to next step
     */
    next() {
      //return

      if (this.instructor > -1 && this.currentUser && this.currentUser.books && this.currentUser.books.length > 0) {
        const selectedInstructor = this.instructors[this.instructor]
        this.report.instructor = selectedInstructor.instructor
        this.report.instructorId = selectedInstructor.instructorId
        if (
          selectedInstructor &&
          this.report &&
          this.report.id &&
          this.report.id > 0 &&
          this.report.bookId &&
          this.report.bookId > 0
        ) {
          API.updateReport(this.report.bookId, this.report.id, {
            data: this.report,
          })
            .then(response => {               
              const params = {report: this.report, goto: 'element'}
              // Fire goto
              // @arg The argument is a object representing report
              this.$emit("goto", params);
            })
            .catch((error) => {
              console.log("Error: " + error);
            });
        }
      }
    },
  },
};
</script>

<style lang="scss"></style>
